import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import DashboardLayout from '../layouts/DashboardLayout';
import Heading from '../Heading';
import { FormattedMessage } from 'react-intl';
import useAuthenticationStore from '@/stores/AuthenticationStore';
import dayjs from 'dayjs';
import ConnectionsPanel from '../settings/ConnectionsPanel';
import GeneralPanel from '../settings/GeneralPanel';
import SecurityPanel from '../settings/SecurityPanel';
import { Helmet } from 'react-helmet';
import useIntlMemo from '@/hooks/useIntlMemo';
import { Navigate, useNavigate, useParams } from 'react-router';
import { DynamicWebRoutes } from '@/utils/constants';
import { SettingPanels } from '@/types/client';
import { Avatar, Tabs, Text } from '@mantine/core';
import styles from './AccountSettings.module.scss';
var PANELS = [
    SettingPanels.GENERAL,
    SettingPanels.SECURITY,
    SettingPanels.CONNECTIONS
];
export default function AccountSettings() {
    var user = useAuthenticationStore(function(state) {
        return state.user;
    });
    var _useParams_panel;
    var panel = (_useParams_panel = useParams().panel) !== null && _useParams_panel !== void 0 ? _useParams_panel : SettingPanels.GENERAL;
    var navigate = useNavigate();
    var title = useIntlMemo(function(intl) {
        if (panel === SettingPanels.GENERAL) {
            return intl.formatMessage({
                id: "yuiyES",
                defaultMessage: [
                    {
                        type: 0,
                        value: "General Settings"
                    }
                ]
            });
        } else if (panel === SettingPanels.SECURITY) {
            return intl.formatMessage({
                id: "v+mwRa",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Security Settings"
                    }
                ]
            });
        } else if (panel === SettingPanels.CONNECTIONS) {
            return intl.formatMessage({
                id: "l9CREU",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Connections"
                    }
                ]
            });
        }
        return undefined;
    }, [
        panel
    ]);
    if (!PANELS.includes(panel)) {
        return /*#__PURE__*/ _jsx(Navigate, {
            to: DynamicWebRoutes.SETTINGS(SettingPanels.GENERAL)
        });
    }
    return /*#__PURE__*/ _jsxs(DashboardLayout, {
        containerProps: {
            size: 'lg'
        },
        children: [
            /*#__PURE__*/ _jsx(Helmet, {
                title: title
            }),
            /*#__PURE__*/ _jsx(Heading, {
                size: "sm",
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "NQgbYA",
                    defaultMessage: "Account Settings"
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.settingsHeader,
                children: [
                    /*#__PURE__*/ _jsx(Avatar, {
                        src: user === null || user === void 0 ? void 0 : user.avatar
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.userInfo,
                        children: [
                            /*#__PURE__*/ _jsx(Heading, {
                                size: "sm",
                                children: user === null || user === void 0 ? void 0 : user.displayName
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                size: "sm",
                                className: styles.memberSince,
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "e404GO",
                                    defaultMessage: "Member since {year}",
                                    values: {
                                        year: dayjs(user === null || user === void 0 ? void 0 : user.createdAt).year()
                                    }
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Tabs, {
                value: panel,
                onChange: function(panel) {
                    return navigate(DynamicWebRoutes.SETTINGS(panel));
                },
                children: [
                    /*#__PURE__*/ _jsxs(Tabs.List, {
                        children: [
                            /*#__PURE__*/ _jsx(Tabs.Tab, {
                                size: "lg",
                                value: SettingPanels.GENERAL,
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "1iEPTM",
                                    defaultMessage: "General"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Tabs.Tab, {
                                value: SettingPanels.SECURITY,
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "Py189G",
                                    defaultMessage: "Security"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Tabs.Tab, {
                                value: SettingPanels.CONNECTIONS,
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "l9CREU",
                                    defaultMessage: "Connections"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Tabs.Panel, {
                        className: styles.tabPanel,
                        value: SettingPanels.GENERAL,
                        children: /*#__PURE__*/ _jsx(GeneralPanel, {})
                    }),
                    /*#__PURE__*/ _jsx(Tabs.Panel, {
                        className: styles.tabPanel,
                        value: SettingPanels.SECURITY,
                        children: /*#__PURE__*/ _jsx(SecurityPanel, {})
                    }),
                    /*#__PURE__*/ _jsx(Tabs.Panel, {
                        className: styles.tabPanel,
                        value: SettingPanels.CONNECTIONS,
                        children: /*#__PURE__*/ _jsx(ConnectionsPanel, {})
                    })
                ]
            })
        ]
    });
}
